import { useContext } from 'react';
import { PartnerRefCodeContext } from 'src/common/providers/PartnerRefCodeProvider';

export const usePartnerRefCode = () => useContext(PartnerRefCodeContext);
